//import React, { useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
//import { ISorter } from "../../models/interfaces/ISorter";
import { ITitle } from "../../models/interfaces/ITitle";
import { ILocation } from "../../models/interfaces/ILocation";
import CpntDataTable from "../../components/dataTable/CpntDataTable";
import CpntPagination from "../../components/CpntPagination";
import { useFetchNoticesDemandesQuery } from "../../redux/slice/api/FO/noticeApi";
import { IFilterNoticeDemande, dtoToFilter, filterToQuery, getDefaultFilterNoticeDemande } from "../../models/interfaces/IFilterNoticeDemande";
import { INoticeDemande } from "../../models/interfaces/INotice";
import NoticesDemandesNoticesFilter from "./components/NoticesDemandesNoticesFilter";
import SpinnerEditeurPro from "./components/SpinnerEditeurPro";


//changer ici + count page accueil


const PageModifAutoNotices: React.FC = () => {
  const [listfilter, setListFilter] = useState<IFilterNoticeDemande>();
  const [searchParams, setSearchParams] = useState<IFilterNoticeDemande>();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [isDescending, setIsDescending] = useState<boolean|null>(null);
  const [sortField, setSortField] = useState("");
  const [numberOfResults, setNumberOfResults] = useState<number|null>(null);
  //const [initiateDownload, setInitiateDownload] = useState(false)
  //const [csvDataToDownload, setCsvDataToDownload] = useState(null)
 
  // //const [editeur, setediteur] = useState(""); // État local pour stocker la valeur de l'entrée
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  
  useEffect(() => {
        const storedFilter = localStorage.getItem("IFilterNoticesDemandesNotices");
    //const storedSorter = localStorage.getItem("ISortStore");
    //console.log(storedFilter);
    if (storedFilter !== null && storedFilter !== undefined) { // && storedSorter !== null && storedSorter !== undefined) {
      const filters = JSON.parse(storedFilter);
      //console.log(filters);
      setListFilter(filters);
      setOffset(filters.Offset ?? 0);
      setLimit(filters.Limit ?? 10);
    } else {
      //console.log("ici",getDefaultFilterNoticeDemande());
      setListFilter(getDefaultFilterNoticeDemande());
    }

    // if (storedSorter !== null && storedSorter !== undefined) {
    //   const currSorter:ISorter = JSON.parse(storedSorter);
    //   currSorter?.orderedcolumnid && setSortField(currSorter?.orderedcolumnid);
    //   currSorter?.orderedasc && setIsDescending(!currSorter?.orderedasc);
    // }
   
  }, []);

  useEffect(() => {
    if (listfilter && listfilter !== getDefaultFilterNoticeDemande()) {
      //console.log(listfilter,limit);
      const _filter: IFilterNoticeDemande = filterToQuery({
        ...listfilter,
        ...(sortField !== "" && { SortField: sortField }),
        ...(isDescending !== null && { IsDescending: isDescending }),
        ...(limit >= 10 && { Limit: limit }),
        ...(offset >= 0 && { Offset: offset }) 
      });
      setSearchParams(_filter);
      localStorage.setItem("IFilterNoticesDemandesNotices",JSON.stringify(_filter));
    }
  }, [listfilter, sortField, isDescending, offset, limit]);

  
  const { data: NoticesDemandesResult, isFetching, error } = useFetchNoticesDemandesQuery(searchParams, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParams === null || searchParams === undefined || listfilter === undefined || (searchParams.Limit ?? 0) < 10 ,
  });

  useEffect(() => {
    setNumberOfResults(NoticesDemandesResult?.Quantite ?? null);
    localStorage.setItem(
      "NoticesNavigator",
      JSON.stringify(NoticesDemandesResult?.Demandes?.map(n => ({ Ean: n.Ean, idnotice: n.IdNotice,iddemande: n.Id })))
    );
  }, [NoticesDemandesResult]);
  
  const applyFilter = (data: IFilterNoticeDemande) => {
    setListFilter(data);
    setOffset(0);
    setLimit(10);
  }

  const actions: ILocation[] = [
    {
      PathsName: { Voir: "/modifautonotices/noticedetailsmodifauto/[[Ean]]/[[IdNotice]]/[[Id]]"},
      State: { type_access: "" },
      ClassName: "bi-receipt fs-5 mb-2",
    },
  ];

  const dataHeaderName: ITitle[] = [
    {
      Id: "Id",
      Name: "IdDemande",
      Class: "",
      sorter: (a: INoticeDemande, b: INoticeDemande) =>
        a.Id - b?.Id,
    },
    {
      Id: "IdNotice",
      Name: "IdNotice",
      Class: "",
      sorter: (a: INoticeDemande, b: INoticeDemande) =>
        a.Id - b?.Id,
    },
    
 
    // {
    //   Id: "IdTypeDemande",
    //   Name: "Type de demande",
    //   Class: "",
    //   sorter: (a: IMessageList, b: IMessageList) =>
    //     (a?.IdTypeDemande ? a?.IdTypeDemande : -1) - (b?.IdTypeDemande ? b?.IdTypeDemande : -1),
    // },
    // {
    //   Id: "MarqueLibelle",
    //   Name: "Libellé de la marque",
    //   Class: "",
    //   sorter: (a: IMessageList, b: IMessageList) =>
    //     a?.MarqueLibelle?.localeCompare(b?.MarqueLibelle),
    // },
    // {
    //   Id: "EmailDemandeur",
    //   Name: "E-mail du demandeur",
    //   Class: "",
    //   sorter: (a: IMessageList, b: IMessageList) =>
    //     a?.MarqueLibelle?.localeCompare(b?.MarqueLibelle),
    // },
    {
      Id: "Ean",
      Name: "Ean",
      Class: "",
      sorter: (a: INoticeDemande, b: INoticeDemande) =>
        a?.Ean?.localeCompare(b?.Ean),
    },
    {
      Id: "DateMaj",
      Name: "Date de la demande",
      Class: "",
      sorter: (a: INoticeDemande, b: INoticeDemande) =>
        a.DateMaj.localeCompare(b.DateMaj),
    },
    // {
    //   Id: "DateReponse",
    //   Name: "Date de traitement",
    //   Class: "",
    //   sorter: (a: IMessageList, b: IMessageList) =>
    //     a.DateReponse.localeCompare(b.DateReponse),
    // },
    // {
    //   Id: "IdTypeReponse",
    //   Name: "Date de traitement",
    //   Class: "",
    //   sorter: (a: IMessageList, b: IMessageList) =>
    //     (a?.IdTypeReponse ? a?.IdTypeReponse : -1) - (b?.IdTypeReponse ? b?.IdTypeReponse : -1),
    // },
    // {
    //   Id: "IdTypeReponse",
    //   Name: "Statut du message",
    //   Class: "",
    //   sorter: (a: IMessageList, b: IMessageList) =>
    //     (a?.IdTypeReponse ? a?.IdTypeReponse : -1) - (b?.IdTypeReponse ? b?.IdTypeReponse : -1),
    // },
  ];


  const dataItemsStyle = {
    Id: "",   
    IdNotice: "",   
    //IdTypeDemande: <HtmlRenderTypeDemandeNoticeMessage />,
    //MarqueLibelle:"",
    //EmailDemandeur:"",
    Ean:"",
    DateMaj:"",
    //DateReponse:"",
    //IdTypeReponse: <HtmlRenderTypeReponseMessage />,
  };

  return (
    <>
     <div className="container text-start ">
      <div className="row pt-3 pb-5">
        <div className="col col-12 ">
          <h2 className="titreModule titre-bleu"><i className="bi-pencil pe-2" />Modifications physiques et commerciales</h2>
        </div>
      </div>
      <div className="row card mb-3 mt-2">
          {searchParams && (
            <>
              <NoticesDemandesNoticesFilter
                filter={dtoToFilter(searchParams)}
                changeFilter={applyFilter}
              />
            {/* Facettes */}
            </>
          )}
           
        </div> 
        <div className="row ">
          {numberOfResults !== null && NoticesDemandesResult?.Demandes && 
            <div className="col-auto pb-3 pt-3">
              Nb de résultats :<b>&nbsp;{numberOfResults}&nbsp;</b>
            </div>
          }
          {isFetching ? (
            <div className="d-flex justify-content-center">
              <SpinnerEditeurPro />
            </div>
          ) : error ? (
            <div>Error</div>
          ) : (
            NoticesDemandesResult?.Demandes && numberOfResults !== null && numberOfResults > 0 &&
              <>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              <div className="card p-0 mb-2">
                <div className="table-responsive">
                  <CpntDataTable
                    data={NoticesDemandesResult && NoticesDemandesResult?.Demandes ? [...NoticesDemandesResult.Demandes] : []}
                    dataHeader={dataHeaderName}
                    dataItemsStyle={dataItemsStyle}
                    actions={actions}
                    actualFilterPage="PageNoticesDemandes"
                    updateSorter={setSortField}
                    updateDescending={setIsDescending}
                />
                </div>
              </div>
              <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>

              </>
          )}
        </div>
      </div>
    </>);
};

export default PageModifAutoNotices;


